import React from 'react';

import { IconProps } from '../../DefaultIcon';

export function ProposalsIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4_4586)">
        <path
          d="M54.3807 63.0815H25.3777V74.6827H54.3807V63.0815Z"
          fill="#EAEEF9"
        />
        <path
          d="M75.6496 65.2568H4.35045C1.93353 65.2568 0 63.3233 0 60.9063V4.35045C0 1.93353 1.93353 0 4.35045 0H75.6496C78.0665 0 80 1.93353 80 4.35045V60.9063C80 63.3233 77.8248 65.2568 75.6496 65.2568Z"
          fill="#EAEEF9"
        />
        <path
          d="M72.2659 54.139H7.73413C6.52567 54.139 5.5589 53.1723 5.5589 51.9638V7.73419C5.5589 6.52573 6.52567 5.55896 7.73413 5.55896H72.2659C73.4743 5.55896 74.4411 6.52573 74.4411 7.73419V51.9638C74.4411 53.1723 73.4743 54.139 72.2659 54.139Z"
          fill="white"
        />
        <path
          d="M66.4653 80H13.5347C12.0846 80 10.8761 78.7915 10.8761 77.3414C10.8761 75.8912 12.0846 74.9244 13.5347 74.9244H66.4653C67.9154 74.9244 69.1239 76.1329 69.1239 77.583C68.8822 78.7915 67.9154 80 66.4653 80Z"
          fill="#EAEEF9"
        />
        <path
          d="M39.1541 12.0846H22.4773C21.9939 12.0846 21.5106 11.6013 21.5106 10.8762C21.5106 10.3928 21.9939 9.66772 22.719 9.66772H39.3958C39.8791 9.66772 40.6042 10.1511 40.6042 10.8762C40.3625 11.6013 39.8791 12.0846 39.1541 12.0846Z"
          fill="#00C4B3"
        />
        <path
          d="M47.6133 30.9366H31.9033C31.4199 30.9366 30.6949 30.4532 30.6949 29.9698C30.6949 29.4864 31.1782 28.7614 31.9033 28.7614H47.6133C48.0967 28.7614 48.5801 29.2447 48.5801 29.9698C48.5801 30.4532 48.0967 30.9366 47.6133 30.9366Z"
          fill="#00C4B3"
        />
        <path
          d="M31.9033 26.1027H22.4773C21.994 26.1027 21.2689 25.6193 21.2689 24.8943C21.2689 24.4109 21.7523 23.9275 22.4773 23.9275H31.9033C32.3867 23.9275 32.8701 24.4109 32.8701 24.8943C33.1118 25.6193 32.6284 26.1027 31.9033 26.1027Z"
          fill="#00C4B3"
        />
        <path
          d="M42.7795 40.3625H22.4773C21.994 40.3625 21.2689 39.8791 21.2689 39.154C21.2689 38.6706 21.7523 38.1873 22.4773 38.1873H42.7795C43.2628 38.1873 43.7462 38.6706 43.7462 39.154C43.9879 39.8791 43.5045 40.3625 42.7795 40.3625Z"
          fill="#00416B"
        />
        <path
          d="M32.3867 44.9546H22.4773C21.994 44.9546 21.2689 44.4713 21.2689 43.7462C21.2689 43.2628 21.7523 42.7794 22.4773 42.7794H32.3867C32.8701 42.7794 33.3535 43.2628 33.3535 43.7462C33.3535 44.4713 32.8701 44.9546 32.3867 44.9546Z"
          fill="#00C4B3"
        />
        <path
          d="M49.0634 16.6767H31.9033C31.4199 16.6767 30.6949 16.1933 30.6949 15.4682C30.9365 14.9848 31.4199 14.5015 31.9033 14.5015H49.0634C49.5468 14.5015 50.2719 14.9848 50.2719 15.7099C50.0302 16.1933 49.5468 16.6767 49.0634 16.6767Z"
          fill="#00416B"
        />
        <path
          d="M39.8791 35.5287H31.9033C31.4199 35.5287 30.6949 35.0454 30.6949 34.3203C30.6949 33.8369 31.1782 33.1118 31.9033 33.1118H39.8791C40.3625 33.1118 40.8459 33.5952 40.8459 34.3203C41.0876 35.0454 40.6042 35.5287 39.8791 35.5287Z"
          fill="#00C4B3"
        />
        <path
          d="M42.5378 49.7885H31.9033C31.4199 49.7885 30.6949 49.3051 30.6949 48.8217C30.6949 48.3384 31.1782 47.6133 31.9033 47.6133H42.5378C43.0211 47.6133 43.5045 48.0967 43.5045 48.8217C43.5045 49.3051 43.0211 49.7885 42.5378 49.7885Z"
          fill="#00C4B3"
        />
        <path
          d="M56.3142 40.3625H48.3384C47.855 40.3625 47.1299 39.8791 47.1299 39.154C47.1299 38.6706 47.6133 38.1873 48.3384 38.1873H56.3142C56.7976 38.1873 57.281 38.6706 57.281 39.154C57.281 39.8791 56.7976 40.3625 56.3142 40.3625Z"
          fill="#00C4B3"
        />
        <path
          d="M49.0635 44.9546H37.7039C37.2206 44.9546 36.4955 44.4713 36.4955 43.7462C36.4955 43.2628 36.9789 42.7794 37.7039 42.7794H49.0635C49.5468 42.7794 50.2719 43.2628 50.2719 43.7462C50.0302 44.4713 49.5468 44.9546 49.0635 44.9546Z"
          fill="#00C4B3"
        />
        <path
          d="M39.8791 21.5106H31.9033C31.4199 21.5106 30.6949 21.0272 30.6949 20.3021C30.9365 19.8187 31.4199 19.3353 31.9033 19.3353H39.8791C40.6042 19.3353 41.0876 19.8187 41.0876 20.3021C41.0876 21.0272 40.6042 21.5106 39.8791 21.5106Z"
          fill="#00C4B3"
        />
        <path
          d="M64.29 30.9366H52.9305C52.4471 30.9366 51.722 30.4532 51.722 29.9698C51.722 29.4864 52.2054 28.7614 52.9305 28.7614H64.29C64.7734 28.7614 65.2568 29.2447 65.2568 29.9698C65.2568 30.4532 64.7734 30.9366 64.29 30.9366Z"
          fill="#00C4B3"
        />
        <path
          d="M66.4653 16.6767H54.3807C53.8973 16.6767 53.1722 16.1933 53.1722 15.4682C53.1722 14.9848 53.6556 14.2598 54.3807 14.2598H66.4653C66.9486 14.2598 67.432 14.7431 67.432 15.4682C67.432 16.1933 66.9486 16.6767 66.4653 16.6767Z"
          fill="#00C4B3"
        />
        <path
          d="M59.2145 21.5106H45.4381C44.9547 21.5106 44.2296 21.0272 44.2296 20.3021C44.2296 19.8187 44.713 19.3353 45.4381 19.3353H59.2145C59.6979 19.3353 60.1813 19.8187 60.1813 20.3021C60.1813 21.0272 59.6979 21.5106 59.2145 21.5106Z"
          fill="#00416B"
        />
        <path
          d="M60.9063 35.5287H45.1964C44.713 35.5287 43.9879 35.0454 43.9879 34.3203C43.9879 33.8369 44.4713 33.1118 45.1964 33.1118H60.9063C61.3897 33.1118 61.8731 33.5952 61.8731 34.3203C62.1148 35.0454 61.6314 35.5287 60.9063 35.5287Z"
          fill="#00C4B3"
        />
        <path
          d="M59.9396 49.7885H47.855C47.3716 49.7885 46.6465 49.3051 46.6465 48.8217C46.6465 48.3384 47.1299 47.6133 47.855 47.6133H59.9396C60.423 47.6133 61.148 48.0967 61.148 48.8217C60.9063 49.3051 60.423 49.7885 59.9396 49.7885Z"
          fill="#00416B"
        />
        <path
          d="M65.9819 44.9546H54.3807C53.8973 44.9546 53.1722 44.4713 53.1722 43.7462C53.1722 43.2628 53.6556 42.7794 54.3807 42.7794H65.9819C66.4653 42.7794 67.1903 43.2628 67.1903 43.7462C67.1903 44.4713 66.707 44.9546 65.9819 44.9546Z"
          fill="#00C4B3"
        />
        <path
          d="M17.1601 12.0846H13.5348C12.8097 12.0846 12.3263 11.6013 12.3263 10.8762C12.3263 10.3928 12.8097 9.66772 13.5348 9.66772H17.1601C17.6435 9.66772 18.3686 10.1511 18.3686 10.8762C18.1269 11.6013 17.6435 12.0846 17.1601 12.0846Z"
          fill="#00C4B3"
        />
        <path
          d="M17.1601 16.6767H13.5348C13.0514 16.6767 12.3263 16.1933 12.3263 15.4682C12.3263 14.9848 12.8097 14.5015 13.5348 14.5015H17.1601C17.6435 14.5015 18.3686 14.9848 18.3686 15.7099C18.1269 16.1933 17.6435 16.6767 17.1601 16.6767Z"
          fill="#00416B"
        />
        <path
          d="M17.1601 21.5106H13.5348C13.0514 21.5106 12.3263 21.0272 12.3263 20.3021C12.3263 19.8187 12.8097 19.3353 13.5348 19.3353H17.1601C17.6435 19.3353 18.3686 19.8187 18.3686 20.3021C18.1269 21.0272 17.6435 21.5106 17.1601 21.5106Z"
          fill="#00C4B3"
        />
        <path
          d="M17.1601 26.1027H13.5348C13.0514 26.1027 12.3263 25.6193 12.3263 24.8943C12.3263 24.4109 12.8097 23.9275 13.5348 23.9275H17.1601C17.6435 23.9275 18.3686 24.4109 18.3686 24.8943C18.1269 25.6193 17.6435 26.1027 17.1601 26.1027Z"
          fill="#00416B"
        />
        <path
          d="M17.1601 30.9366H13.5348C13.0514 30.9366 12.3263 30.4532 12.3263 29.9698C12.3263 29.4864 12.8097 28.7614 13.5348 28.7614H17.1601C17.6435 28.7614 18.3686 29.2447 18.3686 29.9698C18.1269 30.4532 17.6435 30.9366 17.1601 30.9366Z"
          fill="#00416B"
        />
        <path
          d="M17.1601 35.5287H13.5348C13.0514 35.5287 12.3263 35.0454 12.3263 34.3203C12.3263 33.8369 12.8097 33.1118 13.5348 33.1118H17.1601C17.6435 33.1118 18.3686 33.5952 18.3686 34.3203C18.1269 35.0454 17.6435 35.5287 17.1601 35.5287Z"
          fill="#00416B"
        />
        <path
          d="M17.1601 40.3625H13.5348C13.0514 40.3625 12.3263 39.8791 12.3263 39.154C12.3263 38.6706 12.8097 38.1873 13.5348 38.1873H17.1601C17.6435 38.1873 18.3686 38.6706 18.3686 39.154C18.1269 39.8791 17.6435 40.3625 17.1601 40.3625Z"
          fill="#00C4B3"
        />
        <path
          d="M17.1601 44.9546H13.5348C13.0514 44.9546 12.3263 44.4713 12.3263 43.7462C12.3263 43.2628 12.8097 42.7794 13.5348 42.7794H17.1601C17.6435 42.7794 18.3686 43.2628 18.3686 43.7462C18.1269 44.4713 17.6435 44.9546 17.1601 44.9546Z"
          fill="#00416B"
        />
        <path
          d="M17.1601 49.7885H13.5348C13.0514 49.7885 12.3263 49.3051 12.3263 48.8217C12.3263 48.3384 12.8097 47.6133 13.5348 47.6133H17.1601C17.6435 47.6133 18.3686 48.0967 18.3686 48.8217C18.1269 49.3051 17.6435 49.7885 17.1601 49.7885Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_4586">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
